import { http, httpfb, httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  INVENTORY_LOADING: 'inventory/loading',
  INVENTORY_SET_DATA: 'inventory/set/data',
  INVENTORY_SET_PAGING_DATA: 'inventory/set/paging/data',
  INVENTORY_SET_LIST: 'inventory/set/list',
  INVENTORY_SET_PAGING_LIST: 'inventory/set/paging/list',
  INVENTORY_SET_CHECKED: 'inventory/set/checked',
  INVENTORY_SET_CONFERRED: 'inventory/set/conferred',
  INVENTORY_SET_PAGING_CONFERRED: 'inventory/set/paging/conferred',
  INVENTING_SET_DATA_LIST: 'inventorying/set/data/list',
  INVENTING_SET_DATA_DETAIL: 'inventorying/set/data/detail',
  INVENTORY_SET_LIST_FILTERS: 'inventory/set/list/filters',
  INVENTORY_GET_STATUS: 'inventory/get/status',
};

// Reducer
const initialState = {
  loading: false,
  inventorying_data: [],
  inventorying_data_paging: { limit: 25, offset: 0, total: 0 },
  inventory_detail: [],
  inventory_data: {
    address_key: '',
    items: [],
  },
  inventory_status_list: [],
  inventory_list: [],
  inventory_list_paging: { limit: 25, offset: 0, total: 0 },
  inventory_list_filters: {
    type: '',
    inventory_type: '',
    description: '',
    status: 1,
  },
  inventory_checked: [],
  inventory_checked_paging: { limit: 25, offset: 0, total: 0 },
  inventory_conferred: [],
  inventory_conferred_paging: {
    limit: 25,
    offset: 0,
    total: 0,
    pendent: 0,
    notPendent: 0,
  },
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.INVENTORY_GET_STATUS:
      return { ...state, inventory_status_list: action.payload };
    case Types.INVENTORY_SET_LIST_FILTERS:
      return { ...state, inventory_list_filters: action.payload };
    case Types.INVENTING_SET_DATA_LIST:
      return { ...state, inventorying_data: action.payload };
    case Types.INVENTING_SET_DATA_DETAIL:
      return { ...state, inventory_detail: action.payload };
    case Types.INVENTORY_LOADING:
      return { ...state, loading: action.payload };
    case Types.INVENTORY_SET_DATA:
      return { ...state, inventory_data: action.payload };
    case Types.INVENTORY_SET_PAGING_DATA:
      return { ...state, inventorying_data_paging: action.payload };
    case Types.INVENTORY_SET_LIST:
      return { ...state, inventory_list: action.payload };
    case Types.INVENTORY_SET_PAGING_LIST:
      return { ...state, inventory_list_paging: action.payload };
    case Types.INVENTORY_SET_CHECKED:
      return { ...state, inventory_checked: action.payload };
    case Types.INVENTORY_SET_CONFERRED:
      return { ...state, inventory_conferred: action.payload };
    case Types.INVENTORY_SET_PAGING_CONFERRED:
      return { ...state, inventory_conferred_paging: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  inventoryGetListStatus: (status) => ({
    type: Types.INVENTORY_GET_STATUS,
    payload: status,
  }),
  inventoryListSetFilters: (filters) => ({
    type: Types.INVENTORY_SET_LIST_FILTERS,
    payload: filters,
  }),
  inventoryLoading: (value) => ({
    type: Types.INVENTORY_LOADING,
    payload: value,
  }),
  inventoryingSetDataList: (value) => ({
    type: Types.INVENTING_SET_DATA_LIST,
    payload: value,
  }),
  inventoryingSetDataDetail: (value) => ({
    type: Types.INVENTING_SET_DATA_DETAIL,
    payload: value,
  }),
  inventorySetData: (value) => ({
    type: Types.INVENTORY_SET_DATA,
    payload: value,
  }),
  inventorySetPagingData: (value) => ({
    type: Types.INVENTORY_SET_PAGING_DATA,
    payload: value,
  }),
  inventorySetList: (value) => ({
    type: Types.INVENTORY_SET_LIST,
    payload: value,
  }),
  inventorySetPagingList: (value) => ({
    type: Types.INVENTORY_SET_PAGING_LIST,
    payload: value,
  }),
  inventorySetChecked: (value) => ({
    type: Types.INVENTORY_SET_CHECKED,
    payload: value,
  }),
  inventorySetConferred: (value) => ({
    type: Types.INVENTORY_SET_CONFERRED,
    payload: value,
  }),
  inventorySetPagingConferred: (value) => ({
    type: Types.INVENTORY_SET_PAGING_CONFERRED,
    payload: value,
  }),
  setInventoryingConcluded: (inventory_id, body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/inventario/${inventory_id}/inventoried-position`, body, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getInventoryingDetail: (inventory_id, address_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/${inventory_id}/inventorying/detail/${address_id}`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getInventoryingList: (filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/inventorying/list?${qry}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  setInventoryingUser: ({ id: inventory_id, address_id, type = 'ADD' }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(
          `/v1/inventario/${inventory_id}/inventorying/address/${address_id}?type=${type}`,
          { type },
          {
            timeout: 1000 * 60,
          }
        )
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  delInventoryItem: ({ inventory_id, id }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/inventario/${inventory_id}/remover-item/${id}`, {
          timeout: 1000 * 60,
        })
        .then(() => resolve())
        .catch((error) => reject(error));
    });
  },
  setInventory: (body) => {
    return new Promise((resolve, reject) => {
      http
        .post(`/stock/inventory/free`, body, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getInventoryList: (filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/list?${qry}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  checkIfInventoryIsValid: (inventory_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/${inventory_id}/validar`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getInventoryProductsConferred: (inventory_id, filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/${inventory_id}/produtos/conferido?${qry}`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  postInventoryProductsAddress: ({ inventory_id, address_id, sync_products }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/inventario/adicionar/endereco`, {
          inventory_id,
          address_id,
          sync_products,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  putInventoryItemRejected: ({ inventory_id, item }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/inventario/${inventory_id}/item/reject`, item, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  putInventoryItemAccept: ({ inventory_id, item, erp_idf_sync_diver = false }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(
          `/v1/inventario/${inventory_id}/item/accept`,
          { ...item, erp_idf_sync_diver },
          {
            timeout: 1000 * 60,
          }
        )
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  putChangeAllocatedUser: ({ inventory_id, allocated_user_id, allocated_user }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(
          `/v1/inventario/${inventory_id}/allocated-user`,
          {
            allocated_user,
            allocated_user_id,
          },
          {
            timeout: 1000 * 60,
          }
        )
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  postInventoryProductsVariations: ({ inventory_id, ids, stock_id, position_id }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/inventario/adicionar/variacao`, { ids, stock_id, position_id, inventory_id }, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  postInventorySave: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`v1/inventario/create`, body, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  delInventoryId: (id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/inventario/deletar/${id}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  cancelInventoryId: (id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/inventario/cancelar/${id}`, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  concludeInventoryId: ({ inventory_id, inventory_type, erp_sync_user_choice = undefined }) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/inventario/concluir/${inventory_id}`, {
          inventory_type,
          erp_sync_user_choice,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  sendResetERP: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/inventario/ajuste/resetar/inventario`, body, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  sendWmsStockToERP: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/inventario/adjust/wms/to/erp`, body, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getListStatus: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/status`, body, { timeout: 1000 * 60 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getInventoryData: (inventory_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/${inventory_id}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getDivergenceBetweenErpAndInventory: (inventory_id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/inventario/${inventory_id}/quantidade-divergente`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  checkProductInventoryBlocking: (inventory_id, address_id) => {
    return httpwmsapi
      .get(`/v1/inventario/${inventory_id}/addresses/${address_id}/blocked-by-picking`, { timeout: 1000 * 15 })
      .then(({ data }) => data);
  },
};
